import { render } from "./SamlAuth.vue?vue&type=template&id=77c16520&scoped=true"
import script from "./SamlAuth.vue?vue&type=script&lang=js"
export * from "./SamlAuth.vue?vue&type=script&lang=js"

import "./SamlAuth.vue?vue&type=style&index=0&id=77c16520&lang=sass&scoped=true"

import exportComponent from "../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77c16520"]])

export default __exports__